import { render, staticRenderFns } from "./PopupNotiPublic.vue?vue&type=template&id=30c49478&scoped=true&"
import script from "./PopupNotiPublic.vue?vue&type=script&lang=ts&"
export * from "./PopupNotiPublic.vue?vue&type=script&lang=ts&"
import style0 from "./PopupNotiPublic.vue?vue&type=style&index=0&id=30c49478&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c49478",
  null
  
)

export default component.exports